import { create } from 'zustand'

type LoaderStore = {
  count: number
  increment: () => void
  decrement: () => void
}
export const useLoaderStore = create<LoaderStore>((set) => ({
  count: 0,
  increment: () => {
    set({ count: 1 })
  },
  decrement: () => {
    set({ count: 0 })
  },
}))
